import { useCallback, useEffect, useMemo, useState } from "react"
import TableHeader from "../Components/TableHeader"
import core from "../core";
import { Download } from "react-bootstrap-icons";
import TableLoader from "../Components/TableLoader";
import TableFoot from "../Components/TableFoot";
import ExportModal from "../Components/ExportModal";
import api from "../lib/api";
import useNotify from "../hooks/useNotify";
import useListData from "../hooks/useListData";
import useTableFilter from "../hooks/useTableFilter";
import useSortOptions from "../hooks/useSortOptions";

const WonCars = ({ setNotification }) => {
    const notify = useNotify(setNotification);
    const { filter, setFilter, clampPage } = useTableFilter({
        page: 1, limit: 10, keyword: "", sort_by: "id", sort_order: "DESC",
        auction: "", admin: "", start_date: "", end_date: "",
    });
    const [exportLoad, setExportLoad] = useState(false);
    const [exportLimit, setExportLimit] = useState({ modal: false, limit: "10" });

    const sortBy = useSortOptions("bids-sort-by", notify);
    const onListError = useCallback((err) => notify.error(err), [notify]);
    const { data: wonCars, total, loading } = useListData("/won-vehicles", filter, { onError: onListError });

    const pageCount = useMemo(() => Math.max(1, Math.ceil(total / filter.limit)), [total, filter.limit]);
    useEffect(() => { clampPage(total); }, [total, clampPage]);

    function exportWonCars() {
        setExportLoad(true);
        api.get('/export/won-vehicles', { params: { ...filter, limit: exportLimit.limit } })
            .then((res) => {
                window.open(res.data.url, "_blank", "noopener");
                setExportLimit((prev) => ({ ...prev, modal: false }));
            })
            .catch((err) => notify.error(err, "Export failed."))
            .finally(() => setExportLoad(false));
    }

    return (
        <div className="page-content-container">
            <h2 className="page-title">Won Cars</h2>
            <TableHeader
                setNotification={setNotification}
                exportHandler={() => setExportLimit((prev) => ({ ...prev, modal: true }))}
                exportLoad={exportLoad}
                filter={filter}
                withoutAddNew={true}
                AddNewButtonIcon={Download}
                sortBy={sortBy}
                exportButton={true}
                checkboxes={[]}
                setFilter={setFilter}
            />
            <div className="table-scroll">
                <table className="responsive-d-table">
                    <thead>
                        <tr>
                            <th>Lot</th>
                            <th>Bidder</th>
                            <th>Sale Date</th>
                            <th>Location</th>
                            <th>Name</th>
                            <th>Bid</th>
                            {/* Header said "Title Status" while the cell rendered
                                logs.vin; the label now matches the data. */}
                            <th>VIN</th>
                            <th>Buyer</th>
                            <th>Auction</th>
                            <th>Admin</th>
                            <th>IP Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(!loading && wonCars.length > 0) && wonCars.map((car, id) => (
                            <tr key={car.id} className={(id + 2) % 2 === 0 ? "even-row" : "odd-row"}>
                                <td>{car.lot}</td>
                                <td>{car.bidder}</td>
                                <td>{core.formdatDate(new Date(car.sale_date), "yyyy-mm-dd")}</td>
                                <td>{car.location}</td>
                                <td>{car.name}</td>
                                <td>{car.bid}</td>
                                <td>{car.vin}</td>
                                <td>{car.buyer}</td>
                                <td>{car.auction}</td>
                                <td>{car.admin}</td>
                                <td>{car.ip_address}</td>
                            </tr>
                        ))}
                        {(!loading && wonCars.length === 0) && <tr className="empty-row">
                            <td colSpan={11}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>}
                        {loading && <TableLoader colspan={11} />}
                    </tbody>
                </table>
            </div>
            <TableFoot filter={filter} setFilter={setFilter} count={pageCount} total={total} />
            <ExportModal state={exportLimit} setState={setExportLimit} onExport={exportWonCars} loading={exportLoad} />
        </div>
    )
}

export default WonCars
